(function() {
    "use strict";

    class ProductAddToCart extends HTMLElement {
        constructor() {
            super();
            this.addEventListener("click", this.onClick);
        }

        onClick() {
            this.update();
        }

        getSectionsToRender() {
            return [
                {
                    id: "complete-your-look",
                    section: this.getAttribute("data-section-id"),
                    selector: ".add-products__scroll"
                },
                {
                    id: "header",
                    section: "header",
                    selector: ".s-header__buttons"
                }
            ];
        }

        getSectionInnerHTML(responseHtml, selector) {
            return new DOMParser()
                .parseFromString(responseHtml, "text/html")
                .querySelector(selector)
                .innerHTML;
        }

        reRenderSection(response, sectionConfig) {
            const targetElement = 
                (document.getElementById(sectionConfig.id)?.querySelector(sectionConfig.selector)) || 
                document.getElementById(sectionConfig.id);

            if (targetElement && response) {
                targetElement.innerHTML = this.getSectionInnerHTML(
                    response.sections[sectionConfig.section],
                    sectionConfig.selector
                );
            } else {
                console.error(`ERROR Updating cart side sections. Section: ${sectionConfig.id}`);
            }
        }

        update() {
            const productId = this.getAttribute("data-product-id");
            
            // Get product data from the data attribute
            try {
                const productData = JSON.parse(this.getAttribute("data-product-data"));
                
                window.dataLayer.push({
                    event: 'add_to_cart',
                    ecommerce: {
                        item_list_name: 'product_page_completa_tu_look',
                        item_list_id: 'product_page_completa_tu_look',
                        value: (productData.price * 0.01).toFixed(2),
                        currency: window.Shopify?.currency?.active || 'USD',
                        items: [{
                            item_id: productData.id.toString(),
                            item_name: productData.title,
                            item_brand: productData.vendor,
                            item_category: productData.type,
                            price: (productData.price * 0.01).toFixed(2),
                            quantity: 1,
                            item_list_name: 'product_page_completa_tu_look',
                            item_list_id: 'product_page_completa_tu_look'
                        }]
                    }
                });
            } catch (error) {
                console.error('Error parsing product data for analytics:', error);
            }

            const cartData = JSON.stringify({
                items: [{
                    id: productId,
                    quantity: 1
                }],
                sections_url: window.location.pathname,
                sections: this.getSectionsToRender().map(section => section.section)
            });

            fetch(`${routes.cart_add_url}`, {
                ...fetchConfig("javascript"),
                body: cartData
            })
            .then(response => {
                if (response.ok) {
                    return response.text();
                }
                throw Error();
            })
            .then(responseText => {
                const parsedResponse = JSON.parse(responseText);
                this.getSectionsToRender().forEach(section => 
                    this.reRenderSection(parsedResponse, section)
                );
            })
            .catch(() => showToast(window.cartStrings.error));
        }
    }

    function showToast(message, type) {
        const toastElement = document.getElementById("toast");
        const toastBody = toastElement?.querySelector(".toast-body");

        if (!toastElement || !toastBody) return;

        let toastClass = "bg-primary";
        toastClass = "bg-danger";

        toastElement?.classList.remove("bg-danger", "bg-success", "bg-primary");
        toastElement.classList.add(toastClass);
        toastBody.textContent = message;

        new bootstrap.Toast(toastElement, []).show();
    }

    customElements.define("product-add-to-cart", ProductAddToCart);
})();